/**
 * Our analytics consent banner (templates/partials/consent_banner.html), used
 * while AdSense is off. The choice is applied straight away through Consent
 * Mode and saved to the analytics_consent cookie, which
 * templates/partials/consent_mode.html applies on later page loads.
 */

import Cookies from 'js-cookie'

import { COOKIE_OPTIONS } from './preferences.js'

const banner = document.querySelector('[data-consent-banner]')

// Google Analytics sets its cookies on the highest domain it can (e.g.
// .itword.io), and a cookie can only be removed with its own domain, so try
// each level of the hostname.
const removeAnalyticsCookies = () => {
    const labels = location.hostname.split('.')
    const domains = labels.map((_, i) => labels.slice(i).join('.'))
    Object.keys(Cookies.get())
        .filter((name) => /^_g(a|id|at)(_|$)/.test(name))
        .forEach((name) => {
            Cookies.remove(name)
            domains.forEach((domain) => Cookies.remove(name, { domain }))
        })
}

const choose = (granted) => {
    Cookies.set('analytics_consent', String(granted), COOKIE_OPTIONS)
    window.gtag?.('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied',
    })
    if (!granted) removeAnalyticsCookies()
    banner.hidden = true
}

if (banner) {
    // "Privacy settings" buttons start hidden until there's a banner to reopen
    document
        .querySelectorAll('[data-consent-message-only]')
        .forEach((element) => (element.hidden = false))

    banner.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-consent-choice]')
        if (choice) choose(choice.dataset.consentChoice === 'accept')
    })

    document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-privacy-settings]')) return
        banner.hidden = false
        banner.focus()
    })
}
